import head from 'lodash/head';
import isEmpty from 'lodash/isEmpty';
import { authManager } from './managers';

export const userSession = { ready: false };
export const verifyUserSession = () => {
  return new Promise(async (resolve, reject) => {
    const { ready = false } = userSession;
    if (ready) {
      return resolve();
    }

    console.log('Checking firebase user...');
    const user = await new Promise(rslv => {
      authManager.onAuthStateChanged(rslv);
    });

    if (isEmpty(user)) {
      return reject();
    }

    userSession.ready = true;
    resolve();
  });
};

export const isUserSessionHasFacebookAuth = user => {
  return new Promise(resolve => {
    if (!isEmpty(user)) {
      const { providerData = [] } = user;
      const { providerId } = head(providerData);
      if (providerId === 'facebook.com') {
        return resolve(true);
      }
    }

    resolve(false);
  });
};

export const getUserSessionIdtoken = (forceRefresh = false) => {
  return new Promise(resolve => {
    const user = authManager.getCurrentUser();
    if (isEmpty(user)) {
      return resolve('');
    }

    if (user) {
      user
        .getIdToken(forceRefresh)
        .then(resolve)
        .catch(() => {
          resolve('');
        });
    }
  });
};
